export default "__VITE_ASSET__Dj5TY0Ir__"